import { commonjsGlobal as f } from "./index168.js";
import { __exports as r } from "./index192.js";
import "./index190.js";
import { __exports as I } from "./index193.js";
var l = f && f.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(i, o) {
      i.__proto__ = o;
    } || function(i, o) {
      for (var u in o)
        Object.prototype.hasOwnProperty.call(o, u) && (i[u] = o[u]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function i() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (i.prototype = n.prototype, new i());
  };
}(), s = f && f.__assign || function() {
  return s = Object.assign || function(e) {
    for (var t, n = 1, i = arguments.length; n < i; n++) {
      t = arguments[n];
      for (var o in t)
        Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
    }
    return e;
  }, s.apply(this, arguments);
};
Object.defineProperty(r, "__esModule", { value: !0 });
r.cloneNode = r.hasChildren = r.isDocument = r.isDirective = r.isComment = r.isText = r.isCDATA = r.isTag = r.Element = r.Document = r.CDATA = r.NodeWithChildren = r.ProcessingInstruction = r.Comment = r.Text = r.DataNode = r.Node = void 0;
var a = I, b = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), g(this, t);
    }, e;
  }()
);
r.Node = b;
var d = (
  /** @class */
  function(e) {
    l(t, e);
    function t(n) {
      var i = e.call(this) || this;
      return i.data = n, i;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b)
);
r.DataNode = d;
var v = (
  /** @class */
  function(e) {
    l(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = a.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(d)
);
r.Text = v;
var x = (
  /** @class */
  function(e) {
    l(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = a.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(d)
);
r.Comment = x;
var T = (
  /** @class */
  function(e) {
    l(t, e);
    function t(n, i) {
      var o = e.call(this, i) || this;
      return o.name = n, o.type = a.ElementType.Directive, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(d)
);
r.ProcessingInstruction = T;
var m = (
  /** @class */
  function(e) {
    l(t, e);
    function t(n) {
      var i = e.call(this) || this;
      return i.children = n, i;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(b)
);
r.NodeWithChildren = m;
var O = (
  /** @class */
  function(e) {
    l(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = a.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.CDATA = O;
var P = (
  /** @class */
  function(e) {
    l(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = a.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.Document = P;
var j = (
  /** @class */
  function(e) {
    l(t, e);
    function t(n, i, o, u) {
      o === void 0 && (o = []), u === void 0 && (u = n === "script" ? a.ElementType.Script : n === "style" ? a.ElementType.Style : a.ElementType.Tag);
      var c = e.call(this, o) || this;
      return c.name = n, c.attribs = i, c.type = u, c;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(i) {
          var o, u;
          return {
            name: i,
            value: n.attribs[i],
            namespace: (o = n["x-attribsNamespace"]) === null || o === void 0 ? void 0 : o[i],
            prefix: (u = n["x-attribsPrefix"]) === null || u === void 0 ? void 0 : u[i]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(m)
);
r.Element = j;
function C(e) {
  return (0, a.isTag)(e);
}
r.isTag = C;
function E(e) {
  return e.type === a.ElementType.CDATA;
}
r.isCDATA = E;
function _(e) {
  return e.type === a.ElementType.Text;
}
r.isText = _;
function N(e) {
  return e.type === a.ElementType.Comment;
}
r.isComment = N;
function D(e) {
  return e.type === a.ElementType.Directive;
}
r.isDirective = D;
function w(e) {
  return e.type === a.ElementType.Root;
}
r.isDocument = w;
function S(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
r.hasChildren = S;
function g(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (_(e))
    n = new v(e.data);
  else if (N(e))
    n = new x(e.data);
  else if (C(e)) {
    var i = t ? h(e.children) : [], o = new j(e.name, s({}, e.attribs), i);
    i.forEach(function(A) {
      return A.parent = o;
    }), e.namespace != null && (o.namespace = e.namespace), e["x-attribsNamespace"] && (o["x-attribsNamespace"] = s({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (o["x-attribsPrefix"] = s({}, e["x-attribsPrefix"])), n = o;
  } else if (E(e)) {
    var i = t ? h(e.children) : [], u = new O(i);
    i.forEach(function(y) {
      return y.parent = u;
    }), n = u;
  } else if (w(e)) {
    var i = t ? h(e.children) : [], c = new P(i);
    i.forEach(function(y) {
      return y.parent = c;
    }), e["x-mode"] && (c["x-mode"] = e["x-mode"]), n = c;
  } else if (D(e)) {
    var p = new T(e.name, e.data);
    e["x-name"] != null && (p["x-name"] = e["x-name"], p["x-publicId"] = e["x-publicId"], p["x-systemId"] = e["x-systemId"]), n = p;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
r.cloneNode = g;
function h(e) {
  for (var t = e.map(function(i) {
    return g(i, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
export {
  r as default
};
